export const flatArrayToTwoColumns = <T>(arr: T[]): T[][] => {
  const ceiledCenter = Math.ceil(arr.length / 2)
  const left = arr.slice(0, ceiledCenter)
  const right = arr?.slice(ceiledCenter, arr.length)

  return [left, right]
}
